import React from "react";
import { Layout as SiteLayout, Row, Col } from "antd";

export const Header: React.FC = () => {
  return (
    <SiteLayout.Header
      style={{ position: "inherit", zIndex: 1, width: "100%" }}
    >
    <Row align="middle" style={{ height: 64 }} justify="space-between">
      <Col>
        <img src="https://ilivestock.co.uk/dist/images/navigation-bar/full-ilivestock-logo.png" alt="iLivestock Logo" style={{width: "150px"}} />
      </Col>
    </Row>
    </SiteLayout.Header>
  )
}